import makeStyles from '@material-ui/styles/makeStyles';

export default makeStyles((theme) => ({
  root: {
    flexShrink: 0,
  },
}));
